var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkConnected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6d988a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.72.28a1,1,0,0,0-1.37,0L14.3,4.33A5.3,5.3,0,0,0,7.57,5l-.63.63L8.69,7.33l.75-.76a2.82,2.82,0,0,1,4,4l-.76.75,1.75,1.75.63-.63a5.3,5.3,0,0,0,.62-6.73l4-4.05A1,1,0,0,0,19.72.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.56,13.43a2.82,2.82,0,0,1-4-4l.76-.75L5.58,6.94,5,7.57a5.3,5.3,0,0,0-.62,6.73l-4,4.05a1,1,0,0,0,0,1.37,1,1,0,0,0,1.37,0l4.05-4a5.3,5.3,0,0,0,6.73-.62l.63-.63-1.75-1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.24,12.16l.78-.78L11.38,10l.78-.78a.89.89,0,0,0,0-1.25L12,7.84a.89.89,0,0,0-1.25,0L10,8.62,8.62,10l-.78.78a.89.89,0,0,0,0,1.25l.15.15A.89.89,0,0,0,9.24,12.16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkConnected);
export default __webpack_public_path__ + "static/media/link_connected.0e84198687fda91264b62313baabd266.svg";
export { ForwardRef as ReactComponent };